import React from 'react'
import ItemsContainer from './ItemsContainer'

const Footer = () => {
return (
    <footer className="bg-gray-900 text-orange-600">
        <div className="md:flex md:justify-between md:items-center sm:px-12 px-4 bg-[#ffffff19] py-7">
            <h1 className="lg:text-4xl text-3xl md:mb-0 mb-6 lg:leading-normal font-semibold md:w-2/5"><span className="text-teal-400">Free</span> until you're ready to launch</h1>
        </div>
        <ItemsContainer />
    </footer>
)
}

export default Footer